import React from "react";
import { FilterButton, FilterCircle, FilterIcon, FilterIndicatorBadge, FilterLabel } from "../index.styled";
import { ChannelState } from "..";

interface ChannelsFilterIndicatorProps {
    filter: ChannelState;
    count?: number;
    stateFilter?: ChannelState;
    onSelect?: (filter: ChannelState) => void;
    icon: React.ReactNode;
}

const filterColors: Record<ChannelState, string> = {
    all:          'rgb(53 88 218)',
    overdue:      'rgb(221, 72, 53)',
    respond_soon: 'rgb(221, 134, 53)',
    read:         'rgb(10, 10, 10)',
    unread:       'rgb(53, 90, 221)',
    unassigned:   'rgb(51, 198, 189)',
};

const filterLabels: Record<ChannelState, string> = {
    all:          'All',
    overdue:      'Overdue',
    respond_soon: 'Respond Soon',
    read:         'Read',
    unread:       'Unread',
    unassigned:   'Unassigned',
};

const ChannelsFilterIndicator: React.FC<ChannelsFilterIndicatorProps> = ({ filter, count, stateFilter, onSelect, icon }) => {
    return (
        <FilterButton $isUnasigned={filter === 'unassigned'} onClick={() => onSelect?.(filter)}>
            <FilterCircle $isActive={filter === stateFilter} $filterColor={filterColors[filter]}>
                <FilterIcon>{icon}</FilterIcon>
                <FilterIndicatorBadge $color={filterColors[filter]}>{count ?? 0}</FilterIndicatorBadge>
            </FilterCircle>
            <FilterLabel>{filterLabels[filter]}</FilterLabel>
        </FilterButton>
    );
};

export default ChannelsFilterIndicator;